/* eslint-disable max-len */
import PropTypes from 'prop-types';

import IconBase from './icon-base';

const IconDaylightDay = ({ className, height, width }) => (
  <IconBase className={className} viewBox="0 0 32 32" width={width} height={height}>
    <mask
      id="daylight-day-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="6"
      width="31"
      height="16"
    >
      <rect x="1.19482" y="6.3999" width="29.8667" height="15.5307" fill="#D9D9D9" />
    </mask>
    <g mask="url(#daylight-day-mask)">
      <path
        d="M16.1282 15.7332C13.0423 15.7332 10.5282 18.2474 10.5282 21.3332C10.5282 24.4191 13.0423 26.9332 16.1282 26.9332C19.214 26.9332 21.7282 24.4191 21.7282 21.3332C21.7282 18.2474 19.214 15.7332 16.1282 15.7332ZM30.5015 20.4291L24.9773 17.6699L26.9315 11.8132C27.194 11.0199 26.4415 10.2674 25.654 10.5357L19.7973 12.4899L17.0323 6.9599C16.659 6.21324 15.5973 6.21324 15.224 6.9599L12.4648 12.4841L6.60232 10.5299C5.80899 10.2674 5.05649 11.0199 5.32482 11.8074L7.27899 17.6641L1.75482 20.4291C1.00816 20.8024 1.00816 21.8641 1.75482 22.2374L7.27899 24.9966L5.32482 30.8591C5.06232 31.6524 5.81482 32.4049 6.60232 32.1366L12.459 30.1824L15.2182 35.7066C15.5915 36.4532 16.6532 36.4532 17.0265 35.7066L19.7857 30.1824L25.6423 32.1366C26.4357 32.3991 27.1882 31.6466 26.9198 30.8591L24.9657 25.0024L30.4898 22.2432C31.2482 21.8641 31.2482 20.8024 30.5015 20.4291ZM21.4073 26.6124C18.4965 29.5232 13.7598 29.5232 10.849 26.6124C7.93816 23.7016 7.93816 18.9649 10.849 16.0541C13.7598 13.1432 18.4965 13.1432 21.4073 16.0541C24.3182 18.9649 24.3182 23.7016 21.4073 26.6124Z"
        fill="white"
      />
    </g>
    <line y1="23.8201" x2="32" y2="23.8201" stroke="white" />
  </IconBase>
);

IconDaylightDay.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

IconDaylightDay.defaultProps = {
  className: null,
  height: 32,
  width: 32,
};

export default IconDaylightDay;
